import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { EventUsers } from '../../types/Types';

interface UseGetUserProps {
  id: string;
  enabled?: boolean;
}

export function useGetEventUsers({ id, enabled = true }: UseGetUserProps) {
  return useQuery({
    enabled,
    queryKey: ['eventUsers', id],
    queryFn: async () => {
      return axiosInstance<EventUsers>(getAPIURL(`/Event/event/${id}/users`)).then(
        (response) => response.data,
      );
    },
  });
}